/** 工作台 */
export default {
    dataOverview: "数据总览", // 数据总览
    queryBasicData: "查询基础数据", // 查询基础数据
    dataQuery: "数据查询", // 数据查询
    dataOutput: "数据导出", // 数据导出
    dataImportAndExport: "客流数据导入与导出", // 客流数据导入与导出
    entranceAndExitDataQuery: "出入口客流数据查询", // 出入口客流数据查询
    dataCorrection: "数据修正", // 数据修正
    customerPortrait: "客户画像", // 客户画像
    faceRecognitionOfMenAndWomen: "人脸识别男女和顾客年龄分析",
    operationGuide: "操作指南", // 操作指南
    systemOperationFlowchart: "系统操作流程图", // 系统操作流程图
    afterSalesService: "售后服务", // 售后服务
    AfterSalesQA: "售后答疑解惑", // 售后答疑解惑
    operationSystemHeadquartersBranches: "总分馆运营系统", // 总分馆运营系统
    libraryCustomDataLargeScreenCase: "图书馆定制数据大屏案例", // 图书馆定制数据大屏案例
    passengerFlowSystemHeadquartersBranches: "总分馆客流系统", // 总分馆客流系统
    generalCustomDataLargeScreenCase: "通用定制数据大屏案例", // 通用定制数据大屏案例
    realTimePassengerFlowScreen: "实时客流大屏", // 实时客流大屏
    realTimePassengerFlowScreenSubTitle: "实时动态数据大屏案例", // 实时动态数据大屏案例
    simpleCarryingCapacityScreen: "简单承载量数据大屏", // 简单承载量数据大屏
    simpleCarryingCapacityScreenSubTitle: "景区承载量定制数据大屏案例", // 景区承载量定制数据大屏案例
    VRTemplateDataScreen: "VR模板数据大屏", // VR模板数据大屏
    VRTemplateDataScreenSubTitle: "VR展馆定制数据大屏案例", // VR展馆定制数据大屏案例
    // ----------------------------------------------------------------内页部分
    passengerFlowAnalysis: "客流分析", // 客流分析
    passengerFlowPerson: "客流(人)", // 客流(人)
    time: "时间", // 时间
    entityOverview: "实体概览", // 实体概览
    toDayPassengerFlow: "今日客流", // 今日客流
    yesterdayPassengerFlow: "昨日客流", // 昨日客流
    sametimeLastWeek: "上周同期", // 上周同期
    growthAmplitude: "增长幅", // 增长幅
    passengerFlowThisWeek: "本周客流", // 本周客流
    passengerFlowLastWeek: "上周客流", // 上周客流
    passengerFlowThisMonth: "本月客流", // 本月客流
    passengerFlowThisYear: "本年客流", // 本年客流
    lastMonth: "上月客流", // 上月客流
    date: "日期", // 日期
    entityPassengerFlow: "客流分析(最多查询前30条)", // 客流分析(最多查询前30条)
    detailList: "详情列表", // 详情列表
    queryCondition: "查询条件", // 查询条件
    target: "指标", // 指标
    entryNumber: "进人数", // 进人数 walk into
    exitNumber: "出人数", // 出人数 walk out
    passingsNumber: "经过人数", // 经过人数 walk pass
    strand: "滞留人数", // 滞留人数
    groupType: "汇总类型", // 汇总类型
    entityGroup: "按实体汇总", // 按实体汇总
    organizationGroup: "按组织架构汇总", // 按组织架构汇总
    fiveMinute: "五分钟", // 五分钟
    halfHour: "半小时", // 半小时
    hour: "小时", // 小时
    day: "天", // 天
    week: "周", // 周
    month: "月", // 月
    year: "年", // 年
    dimension: "维度", // 维度
    temporalInterval: "时间区间", // 时间区间
}